/* template */
<template><div class="city-main">{{ info.city_name }}<div class="address_bottom" v-if="(info.city_code_gp)">{{ info.city_code_gp }} {{ info.is_cn ? '' : info.country_name_cn }}</div></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m6f87e852"}'>
.city-main
  display flex
.address_bottom
  background #fff
  color #999999
  font-size 14px
  margin-left 7px</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m6f87e852"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./single-city-card.mpx.js?isComponent&outputPath=components%2Fsingle-city-card6f87e852%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./single-city-card.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fsingle-city-card6f87e852%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m6f87e852"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/single-city-card6f87e852/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
